module.exports = __webpack_public_path__ + "img/security.a794b97d.svg";